import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgApexchartsModule } from 'ng-apexcharts';
import { AppComponent } from './app.component';
import { NavbarComponent } from './components/shared/navbar/navbar.component';
import { HeaderComponent } from './components/shared/header/header.component';
import { FooterComponent } from './components/shared/footer/footer.component';
import { SidebarComponent } from './components/shared/sidebar/sidebar.component';
import { SearchbarComponent } from './components/shared/searchbar/searchbar.component';
import { StatCardComponent } from './components/shared/stat-card/stat-card.component';
import { HowItWorksSectionComponent } from './components/shared/how-it-works-section/how-it-works-section.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { HowItWorksComponent } from './components/how-it-works/how-it-works.component';
import { SearchComponent } from './components/search/search.component';
import { ContextComponent } from './components/context/context.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { ApiService } from './services/api/api.service';

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    SearchbarComponent,
    StatCardComponent,
    HowItWorksSectionComponent,
    DashboardComponent,
    NotFoundComponent,
    HowItWorksComponent,
    SearchComponent,
    ContextComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgApexchartsModule
  ],
  providers: [ApiService],
  bootstrap: [AppComponent]
})
export class AppModule { }
